<app-page-header title="Bestellingsoverzicht" origin="Bestellingen" routerLink="/orders"></app-page-header>

<div class="loader-container" *ngIf="item">
    <app-loader *ngIf="loading"></app-loader>

    <div class="container-fluid">
        <div id="topBar">
            <div id="nameBar">
                <h4>{{item.name}} - #{{item.number}}</h4>
                <div class="status-group">
                    <small>{{item.created_at | dutchDate}}</small>

                    <div ngbDropdown class="d-inline-block">
                        <span class="statusButton" ngbDropdownToggle [innerHTML]="item.status | status"></span>

                        <div ngbDropdownMenu>
                            <button ngbDropdownItem (click)="setStatus('OPEN')">Open</button>
                            <button ngbDropdownItem (click)="setStatus('PROCESSING')">Verwerken</button>
                            <button ngbDropdownItem (click)="setStatus('PROCESSED')">Verwerkt</button>
                            <button ngbDropdownItem (click)="setStatus('COMPLETED')">Afgerond</button>
                            <button ngbDropdownItem (click)="cancelOrder()">Annuleren</button>
                        </div>
                    </div>

                    <span class="status-divider">|</span>

                    <div ngbDropdown class="d-inline-block print-status-dropdown">
                        <small class="print-label">Print</small>
                        <span class="statusButton" ngbDropdownToggle [innerHTML]="item.print_status | status"></span>

                        <div ngbDropdownMenu>
                            <button ngbDropdownItem (click)="setPrintStatus('OPEN')">Open</button>
                            <button ngbDropdownItem (click)="setPrintStatus('SENT_TO_PRINTER')">Naar printer</button>
                            <button ngbDropdownItem (click)="setPrintStatus('IN_PRODUCTION')">In productie</button>
                            <button ngbDropdownItem (click)="setPrintStatus('SENT')">Verzonden</button>
                            <button ngbDropdownItem (click)="setPrintStatus('COMPLETED')">Afgerond</button>
                        </div>
                    </div>
                </div>
            </div>
            <div ngbDropdown class="icon-btn cursor-pointer">
                <span ngbDropdownToggle>
                    <i class="bi bi-three-dots-vertical"></i>
                </span>

                <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="sendConfirmationMail()">
                        Verstuur ontvangstbestelling opnieuw
                    </button>
                    <button ngbDropdownItem (click)="sendCompletionMail()">
                        Verstuur verwerktmail
                    </button>
                    <button ngbDropdownItem (click)="sendReadyMail()">
                        Verstuur “licenties staan klaar” mail
                    </button>
                    <button ngbDropdownItem (click)="deleteOrder()">
                        Bestelling verwijderen
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid full-size-cards">
        <div class="row mb-4">
            <div class="col-md-4">
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4>Schoolgegevens</h4>
                        <i class="bi bi-pencil" (click)="editOrganisation()"></i>
                    </div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tr>
                                <td>Vestigingsnummer</td>
                                <td>
                                    <a class="p-0 copy" *ngIf="item['organisation_id']"
                                        [routerLink]="['/school/details', item['organisation_id']]">
                                        <ng-container *ngIf="item.organisation_department_number">
                                            {{item.organisation_department_number}}
                                        </ng-container>
                                        <ng-container *ngIf="!item.organisation_department_number">
                                            {{item.organisation_master_identifier}}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="!item.organisation_department_number && !item.organisation_department_number">
                                            {{item.organisation['department_number']}}
                                        </ng-container>
                                    </a>
                                    <ng-container
                                        *ngIf="item.organisation_department_number && !item['organisation_id']">
                                        {{item.organisation_department_number}}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="!item.organisation_department_number && !item['organisation_id']">
                                        {{item.organisation_master_identifier}}
                                    </ng-container>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td width="100">School naam</td>
                                <td>
                                    <p class="m-0 p-0" *ngIf="!item['organisation_id']">
                                        {{item.organisation_name}}
                                    </p>
                                    <a class="p-0 copy" *ngIf="item['organisation_id']"
                                        [routerLink]="['/school/details', item['organisation_id']]">
                                        {{item['organisation']['name']}}
                                    </a>
                                </td>
                                <td>
                                    <span *ngIf="item['organisation_id']">
                                        <i class="bi bi-link-45deg unlink p-3" style="cursor:pointer;"
                                            (click)="clear('organisation_id')">
                                        </i>
                                    </span>
                                    <span *ngIf="!item['organisation_id']">
                                        <i class="bi bi-link-45deg p-3" style="cursor:pointer;"
                                            (click)="selectOrganisation()">
                                        </i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Schoolsoort</td>
                                <td>{{item.organisation_type}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Adres</td>
                                <td>{{item.organisation_address}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Plaats</td>
                                <td>{{item.organisation_postal_code}} {{item.organisation_city}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Land</td>
                                <td>{{item.organisation_country}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Contactpersoon</td>
                                <td>
                                    <ng-container *ngIf="!item['manager_user_id']">{{item.name}}</ng-container>
                                    <p class="copy p-0 mb-0" *ngIf="item['manager_user_id']">{{item['manager']['name']}}
                                    </p>

                                </td>
                                <td>
                                    <i *ngIf="!item['manager_user_id']" class="bi bi-link-45deg" style="cursor:pointer;"
                                        (click)="selectManager()">
                                    </i>
                                    <i *ngIf="item['manager_user_id']" class="bi bi-link-45deg unlink"
                                        style="cursor:pointer;" (click)="clear('manager_user_id')">
                                    </i>
                                </td>
                            </tr>

                            <tr>
                                <td>E-mail</td>
                                <td>
                                    <a class="copy" (click)="copyToClipboard(item.email, $event)"><i
                                            class="bi bi-clipboard"></i> {{item.email}}</a>
                                </td>
                                <td></td>
                            </tr>

                            <tr *ngIf="item.organisation_master_identifier">
                                <td>Master identifier</td>
                                <td>
                                    {{item.organisation_master_identifier}}
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4>Bestelinformatie</h4>
                        <i class="bi bi-pencil" (click)="selectPeriod()"></i>
                    </div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tr>
                                <td width="140">Bestelnummer</td>
                                <td>{{item.number}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Besteldatum</td>
                                <td>{{item.created_at | dutchDate}}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Bestelbedrag (excl.)</td>
                                <td>{{item.total_price_excl | eur}}</td>
                                <td></td>
                            </tr>
                            <tr *ngIf="item['shipping_name']">
                                <td>Ter attentie van</td>
                                <td>{{ item['shipping_name'] }}</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Schooljaar</td>
                                <td *ngIf="item['period']">{{item['period']['name']}}</td>
                                <td *ngIf="!item['period']">-</td>
                                <td class="text-end">
                                    <span *ngIf="!item['period']">
                                        <i class="bi bi-link-45deg p-3" style="cursor:pointer;"
                                            (click)="selectPeriod()">
                                        </i>
                                    </span>
                                    <span *ngIf="item['period']">
                                        <i class="bi bi-link-45deg unlink p-3" style="cursor:pointer;"
                                            (click)="clear('period_id')">
                                        </i>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>Bron</td>
                                <td>
                                    <ng-container *ngIf="item.order_type === 'eduv'">EDU-V
                                        ({{item.client.name}})</ng-container>
                                    <ng-container *ngIf="item.order_type !== 'eduv'">NEO (handmatig)</ng-container>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Opmerking</td>
                                <td>
                                    {{item.organisation_note}}
                                </td>
                                <td></td>
                            </tr>
                            <tr *ngIf="item.organisation_description">
                                <td>Opmerking</td>
                                <td>
                                    {{item.organisation_description}}
                                </td>
                                <td></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h4>Facturatie gegevens</h4>
                        <i class="bi bi-pencil" (click)="editInformation()"></i>
                    </div>
                    <div class="card-body">
                        <table class="table table-striped">
                            <tr>
                                <td>Inkoopnummer</td>
                                <td>{{item.purchase_number}}</td>
                            </tr>
                            <tr>
                                <td>Factuurnummer</td>
                                <td>Nog niet bekend</td>
                            </tr>
                            <tr>
                                <td>Factuur</td>
                                <td>
                                    <a class="copy" (click)="copyToClipboard(item.invoice_email, $event)">
                                        <i class="bi bi-clipboard"></i> {{item.invoice_email}}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>Adres</td>
                                <td>{{item.invoice_address}}</td>
                            </tr>
                            <tr>
                                <td>Plaats</td>
                                <td>{{item.invoice_postal_code}} {{item.invoice_city}}</td>
                            </tr>
                            <tr>
                                <td>Land</td>
                                <td>{{item.invoice_country}}</td>
                            </tr>
                            <tr>
                                <td>Moneybird factuur</td>
                                <td>
                                    <span class="text-muted ps-0" *ngIf="!item.moneybird_external_id">Niet bekend</span>
                                    <ng-container
                                        *ngIf="item.moneybird_external_id">{{item.moneybird_external_id}}</ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>Moneybird klant</td>
                                <td>
                                    <span class="text-muted ps-0" *ngIf="!item.moneybird_external_id">Niet bekend</span>
                                    <ng-container
                                        *ngIf="item.moneybird_external_id">{{item.moneybird_external_id}}</ng-container>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8">
                <div class="card mb-3 loader-container">
                    <app-loader *ngIf="itemsLoading"></app-loader>
                    <h4 class="card-header">
                        Artikeloverzicht
                        <i *ngIf="['OPEN', 'PROCESSING'].includes(item.status)" class="bi bi-plus"
                            (click)="openAddProduct()"></i>
                    </h4>
                    <div class="alert alert-warning m-3 d-flex align-items-center justify-content-between"
                        *ngIf="hasPhysicalWithoutShipping">
                        <span>
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>
                            Deze bestelling bevat fysieke producten maar heeft nog geen verzendkosten.
                        </span>
                        <button type="button" class="btn btn-sm btn-outline-dark shipping-calc-btn flex-shrink-0"
                            #shippingPop="ngbPopover" [ngbPopover]="shippingPopover" [autoClose]="'outside'"
                            popoverTitle="Verzendkosten berekenen" popoverClass="shipping-popover"
                            placement="bottom-end" (click)="calculateShipping()">
                            <i class="bi bi-calculator me-1"></i> Bereken verzendkosten
                        </button>
                    </div>

                    <ng-template #shippingPopover>
                        <div class="shipping-popover-body">
                            <div *ngIf="shippingCalcLoading" class="text-center py-3">
                                <span class="spinner-border spinner-border-sm"></span>
                            </div>
                            <ng-container *ngIf="!shippingCalcLoading && shippingBreakdown">
                                <table class="table table-sm shipping-breakdown mb-3">
                                    <tr>
                                        <td>Aantal fysieke artikelen</td>
                                        <td class="text-end">{{shippingBreakdown.totalQuantity}}</td>
                                    </tr>
                                    <tr>
                                        <td>Artikelen per doos</td>
                                        <td class="text-end">{{shippingBreakdown.itemsPerBox}}</td>
                                    </tr>
                                    <tr>
                                        <td>Aantal dozen</td>
                                        <td class="text-end">{{shippingBreakdown.totalBoxes}}</td>
                                    </tr>
                                    <tr class="total-row">
                                        <td>Verzendkosten</td>
                                        <td class="text-end">{{shippingEstimate | eur}}</td>
                                    </tr>
                                </table>
                                <div class="d-flex justify-content-end gap-2">
                                    <button type="button" class="btn btn-sm btn-light"
                                        (click)="closeShippingPopover()">Annuleren</button>
                                    <button type="button" class="btn btn-sm btn-primary"
                                        (click)="saveShippingCosts()">Toepassen</button>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>
                    <div class="p-5 text-center" *ngIf="orderItems && orderItems.length < 1">
                        <span class="text-muted">Nog geen artikelen beschikbaar</span>
                    </div>
                    <table class="table table-striped" *ngIf="orderItems && orderItems.length > 0">
                        <thead>
                            <tr>
                                <th [width]="100">Methode</th>
                                <th [width]="200">Product</th>
                                <th [width]="200">EAN</th>
                                <th [width]="200">Licenties</th>
                                <th [width]="200" class="text-end">Prijs</th>
                                <th [width]="200" class="text-end">Totaal</th>
                                <th [width]="200" class="text-end"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orderItem of orderItems">
                                <td>{{orderItem.course}}</td>
                                <td>{{orderItem.name}}</td>
                                <td>{{orderItem.ean}}</td>
                                <td>{{orderItem.quantity}}</td>
                                <td class="text-end">{{orderItem.price_excl | eur}}</td>
                                <td class="text-end">{{orderItem.total_price | eur}}</td>
                                <td class="text-end">
                                    <span>
                                        <i *ngIf="['OPEN', 'PROCESSING'].includes(item.status)" class="bi bi-trash p-3"
                                            style="cursor:pointer;" (click)="deleteOrderItem(orderItem['id'])">
                                        </i>

                                        <i *ngIf="['OPEN', 'PROCESSING'].includes(item.status)"
                                            class="bi bi-pencil-square p-3" style="cursor:pointer;"
                                            (click)="updateOrderItem(orderItem)">
                                        </i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="tableFooter">
                        <p class="text-end">Subtotaal<span>{{item.total_price_items | eur}}</span></p>
                        <p *ngIf="item.shipping_costs" class="text-end">Verzendkosten <span>{{item.total_shipping_costs
                                | eur}}</span></p>
                        <p class="text-end">9% BTW <span>{{item.total_vat_amount | eur}}</span></p>
                        <p class="text-end">Totaal <span class="bold">{{item.total_price | eur}}</span></p>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card mb-3 loader-container shipment-card">
                    <app-loader *ngIf="shipmentsLoading"></app-loader>
                    <div class="card-header">
                        <h4>Verzendingen</h4>
                        <button type="button" class="btn btn-sm btn-primary" (click)="openShipmentModal()"
                            [disabled]="shipmentActionLoading">
                            <span *ngIf="shipmentActionLoading" class="spinner-border spinner-border-sm me-1"></span>
                            <i *ngIf="!shipmentActionLoading" class="bi bi-plus-lg me-1"></i>
                            Verzending
                        </button>
                    </div>
                    <div class="card-body p-0">
                        <div *ngIf="shipmentError" class="alert alert-danger py-2 mb-3">
                            {{shipmentError}}
                        </div>

                        <div class="p-4 text-center" *ngIf="!shipmentsLoading && shipments.length < 1">
                            <span class="text-muted">Nog geen verzendingen beschikbaar</span>
                        </div>

                        <div class="shipment-list" *ngIf="shipments.length > 0">
                            <div class="shipment-row" *ngFor="let shipment of shipments" role="button" tabindex="0"
                                (click)="openShipmentModal(shipment)" (keyup.enter)="openShipmentModal(shipment)">
                                <div class="shipment-row-main">
                                    <strong>Verzending #{{shipment.number || '-'}}</strong>
                                    <span class="text-muted">{{getShipmentStatusLabel(shipment.status)}}</span>
                                </div>
                                <small class="text-muted">{{shipment.created_at | dutchDate}}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        <h4>Bestelling geschiedenis</h4>
                    </div>
                    <div class="card-body p-4">

                        <div class="timeline">
                            <div class="timeline-item" *ngFor="let action of orderActions">
                                <div class="timeline-icon bg-primary"></div>
                                <div class="timeline-content">
                                    <p class="mb-0">{{action['note']}}</p>
                                    <small class="text-muted">{{action['created_at'] | dutchDate}}</small>
                                    <p *ngIf="action['user']">Door {{action['user']['name']}}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
